import { Box, Typography, styled } from '@mui/material';

export const LicenseSectionContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: theme.spacing(20),
  padding: theme.spacing(3),
  [theme.breakpoints.down('lg')]: {
    padding: theme.spacing(2),
    height: theme.spacing(22),
  },
}));

export const LicenseInfoContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}));

export const LicenseTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: 16,
  lineHeight: '24px',
  color: theme.palette.grey[50],
}));

export const LicenseDescription = styled(Typography)(({ theme }) => ({
  fontWeight: 400,
  fontSize: 16,
  lineHeight: '24px',
  color: theme.palette.grey[50],
}));
